import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './Score.module.scss'

type ScoreProps = FormFieldBaseProps & {
  score?: string | number
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const Score = React.forwardRef<HTMLInputElement, ScoreProps>(
  (
    { fieldClassName, id, name, score, onBlur, onChange, isDisabled = false },
    ref,
  ) => (
    <input
      className={cx(styles.score, fieldClassName)}
      type="radio"
      value={score}
      disabled={isDisabled}
      {...{ id, name, ref, onBlur, onChange }}
    />
  ),
)

type ControlledScoreProps = ControlledFieldProps & Pick<ScoreProps, 'score'>

export const ControlledScore = ({
  control,
  fieldClassName,
  id,
  name,
  score,
  isDisabled,
}: ControlledScoreProps) => (
  <Controller
    render={({ field: { name, ref, onBlur, onChange } }) => (
      <Score
        {...{
          fieldClassName,
          id,
          name,
          ref,
          score,
          onBlur,
          onChange,
          isDisabled,
        }}
      />
    )}
    {...{ control, name }}
  />
)
